/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&name=Alarm&setup=true&lang=js"
export * from "./index.vue?vue&type=script&name=Alarm&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=a58c052c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a58c052c"]])

export default __exports__